module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result24-7e1bf3a34a6bd8fede4f4c2f0cd19629.png";